/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RemoveAffiliateReferrerOptions,
  RemoveAffiliateReferrerStatus200,
  RemoveAffiliateReferrerStatus400,
  RemoveAffiliateReferrerStatus401,
  RemoveAffiliateReferrerStatus403,
  RemoveAffiliateReferrerStatus404,
  RemoveAffiliateReferrerStatus500,
} from '../types/RemoveAffiliateReferrer'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { removeAffiliateReferrer } from '../clients/removeAffiliateReferrer'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const removeAffiliateReferrerMutationKey = () =>
  [{ url: '/v1/affiliate_programs/:program_id/referrers/:referrer_id' }] as const

export function removeAffiliateReferrerMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = removeAffiliateReferrerMutationKey()
  return mutationOptions<
    RemoveAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | RemoveAffiliateReferrerStatus400
      | RemoveAffiliateReferrerStatus401
      | RemoveAffiliateReferrerStatus403
      | RemoveAffiliateReferrerStatus404
      | RemoveAffiliateReferrerStatus500
    >,
    RemoveAffiliateReferrerOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return removeAffiliateReferrer({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description ADMIN, INTEGRATOR, or AFFILIATE_MANAGER required within tenant and assignment scope. Disables the referrer's code for new attributions while preserving historical attribution and reporting.
 * @summary Remove a referrer from a program
 * {@link /v1/affiliate_programs/:program_id/referrers/:referrer_id}
 */
export function useRemoveAffiliateReferrer<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RemoveAffiliateReferrerStatus200,
      ResponseErrorConfig<
        | RemoveAffiliateReferrerStatus400
        | RemoveAffiliateReferrerStatus401
        | RemoveAffiliateReferrerStatus403
        | RemoveAffiliateReferrerStatus404
        | RemoveAffiliateReferrerStatus500
      >,
      RemoveAffiliateReferrerOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? removeAffiliateReferrerMutationKey()

  const baseOptions = removeAffiliateReferrerMutationOptions(config) as UseMutationOptions<
    RemoveAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | RemoveAffiliateReferrerStatus400
      | RemoveAffiliateReferrerStatus401
      | RemoveAffiliateReferrerStatus403
      | RemoveAffiliateReferrerStatus404
      | RemoveAffiliateReferrerStatus500
    >,
    RemoveAffiliateReferrerOptions,
    TContext
  >

  return useMutation<
    RemoveAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | RemoveAffiliateReferrerStatus400
      | RemoveAffiliateReferrerStatus401
      | RemoveAffiliateReferrerStatus403
      | RemoveAffiliateReferrerStatus404
      | RemoveAffiliateReferrerStatus500
    >,
    RemoveAffiliateReferrerOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RemoveAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | RemoveAffiliateReferrerStatus400
      | RemoveAffiliateReferrerStatus401
      | RemoveAffiliateReferrerStatus403
      | RemoveAffiliateReferrerStatus404
      | RemoveAffiliateReferrerStatus500
    >,
    RemoveAffiliateReferrerOptions,
    TContext
  >
}
